import { Component, OnInit } from '@angular/core';
import { IpServiceService } from '../../shared/servicios/ip-service.service';

@Component({
  selector: 'app-ip-verifica',
  templateUrl: './ip-verifica.component.html',
  styleUrls: ['./ip-verifica.component.scss']
})
export class IpVerificaComponent implements OnInit {

  ipAddress;

  constructor(private ip: IpServiceService) { }

  ngOnInit(): void {
    this.getIp();
  }

  getIp() {
    this.ip.getIPAddress().subscribe((data) => {
      console.log(data);
      this.ipAddress = data;
    })
  }

}
